const TABLET_BREAKPOINT = 768;
export const getAdditionalBookingParamsCssClasses = ({ hasSpecialCodes, isLandingPage, }) => {
    const classNames = [];
    if (hasSpecialCodes) {
        classNames.push('has-special-codes');
    }
    if (isLandingPage) {
        classNames.push('landing-page-view');
    }
    return classNames.join(' ');
};
export const getSearchBarStyle = (bannerSettings, width, headerId) => {
    const isShowingStickyHeader = !!headerId;
    const searchBarOffsetNotSet = (bannerSettings === null || bannerSettings === void 0 ? void 0 : bannerSettings.searchBarOffset) == null;
    const ignoreBannerStyling = searchBarOffsetNotSet || isShowingStickyHeader;
    if (ignoreBannerStyling) {
        return {};
    }
    switch (bannerSettings === null || bannerSettings === void 0 ? void 0 : bannerSettings.searchBarAlignment) {
        case 'TOP':
            return getTopAlignmentStyle(bannerSettings);
        case 'MIDDLE':
            return getMiddleAlignmentStyle(bannerSettings, width);
        case 'BOTTOM':
            return getBottomAlignmentStyle(bannerSettings);
        default:
            return {};
    }
};
const getTopAlignmentStyle = (bannerSettings) => ({
    top: `${bannerSettings.searchBarOffset}px`,
});
const getMiddleAlignmentStyle = (bannerSettings, width) => {
    const style = {
        height: 'fit-content',
        'z-index': '10',
    };
    if (width && width > TABLET_BREAKPOINT) {
        style['margin-top'] = `${bannerSettings.searchBarOffset}px`;
        style.top = '50%';
        style.transform = 'translate(0, -50%)';
    }
    return style;
};
const getBottomAlignmentStyle = (bannerSettings) => ({
    bottom: `${bannerSettings.searchBarOffset && bannerSettings.searchBarOffset * -1}px`,
});
